"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Body", {
  enumerable: true,
  get: function get() {
    return _body.Body;
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _link.Link;
  }
});
Object.defineProperty(exports, "MainHeader", {
  enumerable: true,
  get: function get() {
    return _mainHeader.MainHeader;
  }
});
Object.defineProperty(exports, "SecondaryBody", {
  enumerable: true,
  get: function get() {
    return _body.SecondaryBody;
  }
});
Object.defineProperty(exports, "SectionHeader", {
  enumerable: true,
  get: function get() {
    return _sectionHeader.SectionHeader;
  }
});
var _body = require("./components/body");
var _link = require("./components/link");
var _mainHeader = require("./components/main-header");
var _sectionHeader = require("./components/section-header");